/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import './dep-6f3e4f56.mjs';
import { a as _assignValue } from './dep-75df64b1.mjs';
import { a as _castPath, b as _toKey } from './dep-6e04bcaa.mjs';
import { _ as _isIndex } from './dep-52c1d6a9.mjs';
import { i as isObject_1 } from './dep-4efc69ee.mjs';
import './dep-97c71289.mjs';

var assignValue = _assignValue,
  castPath = _castPath,
  isIndex = _isIndex,
  isObject = isObject_1,
  toKey = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);
  var index = -1,
    length = path.length,
    lastIndex = length - 1,
    nested = object;
  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
      newValue = value;
    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }
    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
var _baseSet = baseSet;

export { _baseSet as _ };
//# sourceMappingURL=dep-31e6cb80.mjs.map
